// extracted by mini-css-extract-plugin
var _1 = "buttons__fKJWc";
var _2 = "content__kMOZ3";
var _3 = "has-background__YMsN2";
var _4 = "has-warning__QfOP4";
var _5 = "header__FJe5_";
var _6 = "header-actions__FieYl";
var _7 = "header-colored___05n2";
var _8 = "header-info__Uu78C";
var _9 = "header-no-separator__j6ErM";
var _a = "headline__gZAvt";
var _b = "label__niSM1";
var _c = "panel__wah7i";
var _d = "value__UAGGg";
var _e = "warning__yBUx1";
export { _1 as "buttons", _2 as "content", _3 as "has-background", _4 as "has-warning", _5 as "header", _6 as "header-actions", _7 as "header-colored", _8 as "header-info", _9 as "header-no-separator", _a as "headline", _b as "label", _c as "panel", _d as "value", _e as "warning" }
